import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";

import Gel from "./Gel";

export function GelResults(props) {

  const getActualLanes = () => {

    let laneData = {
      "DNA Ladder": [100, 300, 500, 800, 1000],
      "Sample": [],
      "Control 1": [],
      "Control 2": [],
      "Control 3": [],
      "Control 4": []
    }

    let lanes = [
      "Sample",
      "Control 1",
      "Control 2",
      "Control 3",
      "Control 4"
    ]

    let solutionIDs = {
      "Sample": 6,
      "Control 1": 2,
      "Control 2": 3,
      "Control 3": 4,
      "Control 4": 5
    }

    if(props.prepareGelBox &&
       props.runGel &&
       props.visualizeGel &&
       props.loadDNALadder){

         lanes.forEach((lane)=>{

           let solution = props.interactionProps.solutions[solutionIDs[lane] - 1];

           // Prerequisite conditions for a result
           if(
             solution.solutions["Taq DNA Polymerase"] >= 0.5 &&
             solution.solutions["Buffer"] >= 2.5 &&
             solution.solutions["dNTPs"] >= 0.5 &&
             (
               (
                 solution.solutions["Forward Primer"] >= 0.5 &&
                 solution.solutions["Reverse Primer"] >= 0.5
               )
               ||
               (
                 solution.solutions["Primer Mix of Primers 1 and 6"] >= 1 ||
                 solution.solutions["Primer Mix of Primers 2 and 5"] >= 1 ||
                 solution.solutions["Primer Mix of Primers 3 and 4"] >= 1
               )
             )
           ){

             // Lane conditions for banding data
             if(solution.solutions["DNA A"] >= 1){
                laneData[lane].push(1)
             }
             // Lane conditions for banding data
             if(solution.solutions["DNA B"] >= 1){
                laneData[lane].push(57)
             }
             // Lane conditions for banding data
             if(solution.solutions["DNA C"] >= 1){
                laneData[lane].push(1)
                laneData[lane].push(57)
             }

             if(solution.solutions["Gene X homozygous normal Control DNA"] >= 1){
               laneData[lane].push(1)
             }

             if(solution.solutions["Gene X homozygous mutated Control DNA"] >= 1){
               laneData[lane].push(57)
             }

             // These have no result
             if(solution.solutions["dH20"] > 1){}
             if(solution.solutions["Prokaryotic Control DNA"] >= 1){}
           }
         })
    }

    return laneData

  }

  return (
    <>
      <div className={props.className}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div className="gelPrediction">
            <h5 className="panel-title" style={{ color: "white" }}>
              Predicted results
            </h5>
            <p className="panel-description">
              These are your initial predictions.
            </p>
            <Gel lanes={props.gelDragDropPrediction} />
          </div>
          <div className="gelActual">
            <h5 className="panel-title" style={{ color: "white" }}>
              Actual results
            </h5>
            <p className="panel-description">These are your actual results.</p>
            <Gel
              lanes={getActualLanes()}
            />
          </div>
        </div>
      </div>
      <div className={props.className}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div className="gelIdeal">
            <h5 className="panel-title" style={{ color: "white" }}>
              Ideal results
            </h5>
            <p className="panel-description">
              The sample lane should have one band that is approximately 1000bp.
              The single band that appears in the control lane should appear at
              the same position as the 1000bp mark on the DNA ladder. The
              control 2 lane should line up be to approximately 700 bp. The
              control 3 and control 4 lanes are left intentionally blank.
            </p>
          </div>
          <div className="gelIdeal">
            <Gel
              lanes={
                props.idealData[
                  Object.keys(props.interactionProps.solutions[13].solutions)[0]
                ]
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
GelResults.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  dragdrop: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

GelResults.defaultProps = {
  className: "gelResults",
};
